import { items } from "@/api/items/useItemQuery";
import { KPI } from "@/api/kpi/useKPIQuery";
import { columnlist } from "@/constants/columnlist";
import { useModal } from "@/features/modal/ModalStackManager";
import { Header } from "@/features/standard/Header";
import { HeaderSubTitle } from "@/features/standard/SubTitle";
import { HeaderTitle } from "@/features/standard/Title";
import { ItemAutoComplete } from "@/features/ui/autoComplete/item/item-autoComplete";
import { Calendar, isCalendarDate } from "@/features/ui/Calendar";
import { GridTable } from "@/features/ui/PMS/GridTable";
import CustomTable from "@/features/ui/table/CustomTable";
import timeUtil from "@/utils/timeUtil";
import { ActionIcon, Flex, Space, Text } from "@mantine/core";
import { ItemsGet200ResponseRowsInnerItemTypeEnum } from "@sizlcorp/sizl-api-document/dist/models";
import { IconCalendar } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

const KPILeadTimeOrder = Object.assign({}, {
    Header: Header,
    HeaderTitle: HeaderTitle,
    HeaderSubTitle: HeaderSubTitle,
    CustomTable: CustomTable,
})

export const KPILeadTimeOrderPage = () => {
    const today = dayjs().subtract(1, 'day').startOf('day').toDate();
    const oneWeekAgo = dayjs().subtract(7, 'day').startOf('day').toDate();

    const [content, setContent] = useState<any>([]);
    const [selectList, setSelectList] = useState<Set<number>>(new Set());
    const [stateDate, setStateDate] = useState<[Date | null, Date | null]>([oneWeekAgo, today]);
    const [item, setItem] = useState<string | null>('');
    const [averageLeadTime, setAverageLeadTime] = useState<string>('');
    const { openModal } = useModal();

    const { data } = useQuery({
        ...items.get({
            query: {
                $and: [
                    { code: item }
                ]
            }
        }),
        enabled: !!item
    })

    const itemData = data?.data?.rows && data?.data?.rows[0]

    const TableHeader = {
        machine: ['품목코드', '품명', '규격', '평균 수주/납품 리드타임(일)'],
    }

    const { data: leadTimeOrderData } = useQuery({
        ...KPI.leadTimeOrder({
            itemCode: item ?? '',
            scheduledAtFrom: stateDate[0]?.toISOString() ?? '',
            scheduledAtTo: stateDate[1]?.toISOString() ?? ''
        }),
        enabled: !!item
    })

    useEffect(() => {
        if (leadTimeOrderData?.data) {
            const transformedData = leadTimeOrderData.data.map((leadTimeOrder: any) => ({
                purchaseOrderId: leadTimeOrder.purchaseOrderId,
                contractor: leadTimeOrder.contractor,
                orderDate: timeUtil(leadTimeOrder.orderDate),
                deadline: timeUtil(leadTimeOrder.deadline),
                firstDeliveryTime: timeUtil(leadTimeOrder.firstDeliveryTime),
                orderedQuantity: `${leadTimeOrder.orderedQuantity} ${itemData?.unitText}`,
                deliveredQuantity: `${leadTimeOrder.deliveredQuantity} ${itemData?.unitText}`,
                leadTime: leadTimeOrder.leadTime,
            }));

            const totalLeadTime = leadTimeOrderData?.data?.reduce((sum: number, leadTimeOrder: any) => sum + parseFloat(leadTimeOrder.leadTime), 0) ?? 0;
            const averageLeadTime = (totalLeadTime / leadTimeOrderData.data.length).toFixed(2);
            setAverageLeadTime(averageLeadTime);
            setContent(transformedData);
        } else {
            setContent([]);
        }
    }, [leadTimeOrderData])

    const BodyData = {
        machine: [{ '품목코드': itemData?.code ?? '-', '품명': itemData?.name, '규격': itemData?.spec, '평균 수주/납품 리드타임(일)': averageLeadTime === "NaN" ? '-' : averageLeadTime }],
    }

    return (
        <Flex gap="md" direction={'column'}>
            <KPILeadTimeOrder.Header>
                <KPILeadTimeOrder.HeaderTitle>수주/납품 리드타임(D)</KPILeadTimeOrder.HeaderTitle>
                <KPILeadTimeOrder.HeaderSubTitle>수주 생성일부터 최초 납품일까지 걸린 시간</KPILeadTimeOrder.HeaderSubTitle>
            </KPILeadTimeOrder.Header>
            <Flex justify={'space-between'} align={'center'}>
                <Space miw={'22rem'} />
                <Flex align={'center'}>
                    <Flex align="center" gap="sm" onClick={() => {
                        openModal(<Calendar dates={stateDate} type="range" isExclude={true} />, null, '날짜 선택')
                            .then((value) => {
                                if (isCalendarDate(value)) {
                                    setStateDate(value);
                                }
                            });
                    }}>
                        <Text size="2rem" fw="bold" style={{ cursor: "pointer" }}>
                            {timeUtil(stateDate[0]?.toISOString() ?? '')} ~ {timeUtil(stateDate[1]?.toISOString() ?? '')}
                        </Text>
                        <ActionIcon>
                            <IconCalendar size="2rem" />
                        </ActionIcon>
                    </Flex>
                </Flex>
                <ItemAutoComplete
                    placeholder="품목을 선택해주세요"
                    w="22rem"
                    size="lg"
                    getItemType={[ItemsGet200ResponseRowsInnerItemTypeEnum.PRODUCT, ItemsGet200ResponseRowsInnerItemTypeEnum.SEMI_PRODUCT]}
                    onChange={(value) => setItem(value)}
                />
            </Flex>

            <KPILeadTimeOrder.CustomTable
                headers={TableHeader.machine}
                data={BodyData.machine}
            />
            <GridTable
                headerList={[
                    ...columnlist.leadTimeOrderTable
                ]}
                row={content}
                setRow={setContent}
                selectList={selectList}
                //@ts-ignore
                setSelectList={setSelectList}
                width={'100%'}
                height={750}
                resizable={true}
            // scrollEnd={(value) => {
            //     if(value){
            //         if(keyword !== undefined){
            //             if(searchPage.total_page > searchPage.current_page){
            //                 getPressDailyStatusSearchApi(keyword, searchPage.current_page+ 1)
            //             }
            //         }else{
            //             if(page.total_page > page.current_page){
            //                 getPressDailyStatusApi(page.current_page+ 1)
            //             }
            //         }
            //     }
            // }}
            />
        </Flex>
    )
}